import React from 'react';
import { Snackbar, Button, IconButton, Typography, Box } from '@mui/material';
import { Close, GetApp, IosShare } from '@mui/icons-material';
import { usePWAInstall } from '../../hooks/usePWAInstall';

export default function PWAInstallBanner() {
  const { canPrompt, install, dismiss, isIOS } = usePWAInstall();

  if (!canPrompt) return null;

  // iOS: show manual instruction (Safari doesn't support install prompt)
  if (isIOS) {
    return (
      <Snackbar
        open
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ mb: { xs: 7, md: 0 } }} // above MobileBottomNav
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            bgcolor: 'primary.main',
            color: 'white',
            borderRadius: 2,
            px: 2,
            py: 1.5,
            boxShadow: 6,
            maxWidth: 400,
          }}
        >
          <IosShare sx={{ fontSize: 28 }} />
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle2" fontWeight={700}>
              Instalá Vincula
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.9 }}>
              Tocá <IosShare sx={{ fontSize: 14, verticalAlign: 'middle' }} /> y luego "Agregar a inicio"
            </Typography>
          </Box>
          <IconButton size="small" onClick={dismiss} sx={{ color: 'white' }}>
            <Close fontSize="small" />
          </IconButton>
        </Box>
      </Snackbar>
    );
  }

  // Android/Chrome/Edge: show install button
  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ mb: { xs: 7, md: 0 } }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          bgcolor: 'primary.main',
          color: 'white',
          borderRadius: 2,
          px: 2,
          py: 1.5,
          boxShadow: 6,
          maxWidth: 400,
        }}
      >
        <GetApp sx={{ fontSize: 28 }} />
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle2" fontWeight={700}>
            Instalá Vincula en tu teléfono
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.9 }}>
            Accedé directo desde tu pantalla de inicio
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="small"
          onClick={install}
          sx={{
            bgcolor: 'white',
            color: 'primary.main',
            fontWeight: 700,
            '&:hover': { bgcolor: 'grey.100' },
            textTransform: 'none',
            minWidth: 'auto',
            px: 2,
          }}
        >
          Instalar
        </Button>
        <IconButton size="small" onClick={dismiss} sx={{ color: 'white' }}>
          <Close fontSize="small" />
        </IconButton>
      </Box>
    </Snackbar>
  );
}
